// extracted by mini-css-extract-plugin
module.exports = {"tags":"RenderTags_tags__zl1HS","tags-item":"RenderTags_tags-item__OhcSW"};